export default class Unique {
  private last: number;
  private size: number;
  private taken: Set<number>;

  public constructor({ init = 0, size = Number.MAX_SAFE_INTEGER }: { init?: number, size?: number } = {}) {
    this.size  = Math.min(size, Number.MAX_SAFE_INTEGER);
    this.last  = Math.max(init, 0);
    this.taken = new Set<number>(); // mutable
  }

  public next() {
    let id;

    // first try all of the numbers greater than the last
    for (id = this.last; id < this.size && this.taken.has(id); ++id);
    if (id < this.size) {
      return this.use(id);
    }

    // then start from zero until we go all the way around
    for (id = 0; id < this.last && this.taken.has(id); ++id);
    if (id < this.last) {
      return this.use(id);
    }

    throw new Error('Can\'t allocate new ids anymore, out of range of usable integers');
  }

  public release(id: number) {
    this.taken.delete(id);
    // This will allow to reuse the id next time `next()` is called
    this.last = id;
  }

  private use(id: number) {
    this.taken.add(id);
    this.last = id;
    return id;
  }
}

// convenience global
export const globalUnique = new Unique();
